const tt = {
  Groups: {
    title: "Төркемнәр",
  },
  GroupList: {
    group: "Төркем",
    dates: "Дәресләр вакыты",
    report: "Дәресләр буенча хисаплар",
    statistics: "Платформа статистикасы",
    progress: "Платформаның күтәрелеше",
    lessonsCount: "Дәресләр үткәрелгән",
    total: "Барысы ак. сәг.",
    finished: "Үткәрелгән ак. сәг.",
    left: "Калган ак. сәг.",
    period: "Чор",
    teachers: "Укытучылар",
    attendance: "Дәрестә булу",
  },
  ModalGroupReport: {
    Download: "Чыгарырга",
    Teacher: "Укытучы",
    Course: "Курс",
    Schedule: "Расписание",
    Hours: "ак. сәг.",
    TotalHours: "Барлык ак. сәг.",
    CompletedHours: "Үткәрелгән ак. сәг.",
    LeftHours: "Калган ак. сәг.",
    Compensation: "Компенсация",
    Students: "Студентлар",
    Duration: "Дәвамлылык",
  },
  GroupFilter: {
    ActiveGroups: "Актив төркемнәр",
    ActiveGroupsNo: "Юк",
    ActiveGroupsYes: "Әйе",
    SelectLevel: "Дәрәҗә сайларга",
    SearchStudent: "Студентны эзләү",
    SearchGroup: "Төркемне эзләү",
    SelectModule: "Модуль сайларга",
    AllModules: "Барлык модульләр",
    AllCompanies: "Барлык компанияләр",
    SelectCompany: "Компания сайлау",
    StartDate: "Башлану көне",
    EndDate: "Тәмамлану көне",
    WithLessonsWithoutTeachers: "Укытучысыз",
    WithLessonsOnlyTechnicalCancellationBefore: "ДС. бетерүләр",
    NoOptions: "Вариантлар юк",
    Open: "Ачык",
  },
  GroupDownload: {
    Download: "Чыгарырга",
    Groups: "Төркемнәр",
    WithoutPrice: "Бәя куелмаган төркемнәр",
  },
  GroupsAutocompleteFilter: {
    EnterGroupName: "Төркем исемен языгыз",
    SelectGroup: "Төркем сайлау",
  },
  GroupsEmptyTable: {
    FirstTextDefault: "Сезгә уку модульләре билгеләнмәгән.",
    SecondTextDefault: "Уку координаторыгызга мөрәҗәгать итегез.",
    FirstTextDistributor: "Күрсәтү өчен мәгълүмат юк.",
    SecondTextDistributor: "Нинди дә булса мәгълүмат өстәп карагыз.",
    FirstTextClasses: "Күрсәтү өчен мәгълүматлар юк.",
    SecondTextClasses:
      "Фильтрларны үзгәртеп карагыз яки ярдәмгә мөрәҗәгать итегез.",
  },
  TeachersAutocompleteFilter: {
    EnterTeacherName: "Укытучылар табылмады",
    SelectTeacher: "Укытучы сайлау",
  },
  ShortWeekDay: {
    "0": "ЯК",
    "1": "ДШ",
    "2": "СШ",
    "3": "ЧР",
    "4": "ПҖ",
    "5": "ҖМ",
    "6": "ШМ",
  },
  LessonStatuses: {
    completed: "Үткәрелгән",
    planned: "Планлаштырылган",
    earlyCanceledByCustomer: "Тыңлаучылар тарафыннан алдан бетерелгән",
    earlyCanceledBySchool: "Укытучы тарафыннан алдан бетерелгән",
    lateCanceledByCustomer: "Тыңлаучылар тарафыннан соң бетерү",
    lateCanceledBySchool: "Укытучы тарафыннан соң бетерү",
    notPerformedToPay: "Түләүгә",
  },
  DatePicker: {
    MaskPlaceholder: "ДД/ММ/ГГГГ",
    Today: "Бүген",
    Clear: "Чистарту",
  },
};

export default tt;
